/* eslint-disable no-console */

import { register } from 'register-service-worker'
import {
  checkForUpdate,
  onUpdateReady,
  setRegistration,
} from '@utils/sw-update'

if (process.env.NODE_ENV === 'production') {
  // Older (Vue CLI) builds registered `service-worker.js`. This app now emits
  // `sw.js` via vite-plugin-pwa (see vite.config.js `filename: 'sw.js'`), so
  // unregister any lingering legacy worker. Otherwise a returning user's stale
  // worker keeps serving old precached assets and never updates.
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => {
          const scriptURL =
            registration.active?.scriptURL ||
            registration.waiting?.scriptURL ||
            registration.installing?.scriptURL ||
            ''
          if (scriptURL.endsWith('/service-worker.js')) {
            registration.unregister()
          }
        })
      })
      // getRegistrations() can reject (e.g. restrictive privacy settings). This
      // is only opportunistic cleanup of a legacy worker, so log and move on
      // rather than leaving an unhandled rejection at startup.
      .catch((error) => {
        console.debug('Could not inspect existing service workers:', error)
      })
  }

  register(`${process.env.BASE_URL}sw.js`, {
    registrationOptions: { scope: './' },
    ready(registration) {
      console.debug('Service worker is active.')
    },
    registered(registration) {
      console.debug('Service worker has been registered.')
      // Hand the registration over so the app can check on its own triggers.
      // the tab becoming visible (set up here, inside setRegistration) and route
      // changes (see the router's afterEach). Those are what make a deploy land
      // within about a second of the user coming back or clicking through.
      setRegistration(registration)
      // The backstop, for a tab left open and untouched. `force`, so it is never
      // skipped by the throttle that keeps route changes cheap. Five minutes
      // rather than hourly: this is the longest a user sitting still can stay on
      // an old build. The check is a conditional request against sw.js (served
      // `no-cache`), so it is a 304 in the common case.
      setInterval(
        () => {
          checkForUpdate({ force: true })
        },
        1000 * 60 * 5
      )
    },
    cached(registration) {
      console.debug('Content has been cached for offline use.')
    },
    updatefound(registration) {
      console.debug('New content is downloading.')
    },
    updated(registration) {
      console.debug('New content is available.')
      // Hand off to the module, which applies it as soon as reloading is safe and
      // meanwhile offers the snackbar. The old CustomEvent is kept for anything
      // still listening, but it is no longer how the update is applied. The event
      // could fire before the root component mounted and be missed entirely.
      onUpdateReady(registration)
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline() {
      console.debug(
        'No internet connection found. App is running in offline mode.'
      )
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    },
  })
}
